import { Box } from "@mui/material";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import { handleMultiCheckBoxSelect } from "../../utils";



export const Footer = (props) => {
    const { paginationProps, Pagination,gridList, selectedRowsData,userPermission,setOpenDialog } = props;
    return (
        <GridFooterContainer>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box>{handleMultiCheckBoxSelect(gridList, selectedRowsData,userPermission,setOpenDialog)}</Box>
                <Box>
                    <GridPagination
                        {...paginationProps}
                        ActionsComponent={Pagination}
                    />
                </Box>
            </Box>
        </GridFooterContainer>
    );
};